import RoleManage from './roleManage.vue'
import Add from './add/add-routing'

export default [{
    path: '/roleManage',
    name:'roleManage',
    component:RoleManage,
    children:[...Add]
}]